var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndiaIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2022_998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V8.00156H0V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00195H24V15.9988H0V8.00195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.998H24V23.9996H0V15.998Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15.2008C13.7681 15.2008 15.2008 13.7681 15.2008 12.0008C15.2008 10.2335 13.7681 8.80078 12.0008 8.80078C10.2335 8.80078 8.80078 10.2335 8.80078 12.0008C8.80078 13.7681 10.2335 15.2008 12.0008 15.2008Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 14.8002C13.5456 14.8002 14.7992 13.5466 14.7992 12.0002C14.7992 10.4538 13.5456 9.2002 11.9992 9.2002C10.4528 9.2002 9.19922 10.4538 9.19922 12.0002C9.19922 13.5466 10.4528 14.8002 11.9992 14.8002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 12.5604C12.3087 12.5604 12.5595 12.3097 12.5595 12.0004C12.5595 11.6911 12.3087 11.4404 11.9995 11.4404C11.6902 11.4404 11.4395 11.6911 11.4395 12.0004C11.4395 12.3097 11.6902 12.5604 11.9995 12.5604Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7556 12.5104C14.8344 12.5208 14.9068 12.4653 14.9171 12.3864C14.9275 12.3076 14.872 12.2352 14.7932 12.2249C14.7143 12.2145 14.642 12.27 14.6316 12.3488C14.6212 12.4277 14.6767 12.5 14.7556 12.5104Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 14.8013L12.0943 13.1213L11.9983 12.3213L11.9023 13.1213L11.9983 14.8013Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5306 13.2059C14.6041 13.2364 14.6883 13.2015 14.7188 13.128C14.7492 13.0545 14.7143 12.9703 14.6409 12.9399C14.5674 12.9094 14.4831 12.9443 14.4527 13.0178C14.4223 13.0913 14.4572 13.1755 14.5306 13.2059Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2751 14.7055L11.8026 13.1076L11.9169 12.31L11.6172 13.0579L11.2751 14.7055Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1342 13.821C14.1973 13.8694 14.2877 13.8575 14.3361 13.7944C14.3846 13.7314 14.3726 13.641 14.3096 13.5925C14.2465 13.5441 14.1561 13.556 14.1077 13.6191C14.0592 13.6822 14.0711 13.7726 14.1342 13.821Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6029 14.4262L11.526 13.0193L11.8429 12.2785L11.3598 12.9233L10.6029 14.4262Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5916 14.313C13.64 14.3761 13.7304 14.388 13.7935 14.3396C13.8566 14.2912 13.8685 14.2008 13.8201 14.1377C13.7717 14.0746 13.6813 14.0627 13.6182 14.1111C13.5551 14.1595 13.5432 14.2499 13.5916 14.313Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0213 13.9817L11.2771 12.8616L11.7749 12.228L11.1413 12.7258L10.0213 13.9817Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9384 14.6427C12.9689 14.7161 13.0531 14.751 13.1266 14.7206C13.2001 14.6902 13.235 14.6059 13.2045 14.5325C13.1741 14.459 13.0899 14.4241 13.0164 14.4545C12.9429 14.485 12.908 14.5692 12.9384 14.6427Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57702 13.4003L11.0799 12.6434L11.7248 12.1603L10.9839 12.4771L9.57702 13.4003Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2225 14.7956C12.2329 14.8744 12.3052 14.9299 12.3841 14.9196C12.4629 14.9092 12.5184 14.8369 12.5081 14.758C12.4977 14.6792 12.4253 14.6236 12.3465 14.634C12.2676 14.6444 12.2121 14.7167 12.2225 14.7956Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29635 12.7248L10.9439 12.3827L11.6918 12.083L10.8943 12.1973L9.29635 12.7248Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4916 14.7585C11.4812 14.8373 11.5367 14.9097 11.6155 14.9201C11.6944 14.9304 11.7667 14.8749 11.7771 14.7961C11.7875 14.7172 11.732 14.6449 11.6531 14.6345C11.5743 14.6241 11.5019 14.6796 11.4916 14.7585Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20067 12.0013L10.8807 12.0973L11.6807 12.0013L10.8807 11.9053L9.20067 12.0013Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.795 14.5326C10.7646 14.6061 10.7995 14.6903 10.873 14.7207C10.9464 14.7512 11.0307 14.7163 11.0611 14.6428C11.0915 14.5693 11.0566 14.4851 10.9832 14.4547C10.9097 14.4242 10.8255 14.4591 10.795 14.5326Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29548 11.277L10.8934 11.8046L11.691 11.9189L10.9431 11.6191L9.29548 11.277Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1819 14.1352C10.1335 14.1983 10.1454 14.2887 10.2085 14.3371C10.2716 14.3855 10.362 14.3736 10.4104 14.3105C10.4588 14.2474 10.4469 14.157 10.3838 14.1086C10.3207 14.0602 10.2303 14.0721 10.1819 14.1352Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57574 10.6019L10.9827 11.5251L11.7235 11.8419L11.0787 11.3588L9.57574 10.6019Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68895 13.5926C9.62586 13.641 9.61395 13.7314 9.66237 13.7945C9.71078 13.8576 9.80118 13.8695 9.86427 13.8211C9.92737 13.7726 9.93927 13.6823 9.89085 13.6192C9.84244 13.5561 9.75204 13.5442 9.68895 13.5926Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0183 10.0223L11.1384 11.2781L11.772 11.7759L11.2742 11.1423L10.0183 10.0223Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36026 12.9404C9.28679 12.9708 9.2519 13.0551 9.28233 13.1285C9.31277 13.202 9.397 13.2369 9.47048 13.2065C9.54395 13.176 9.57884 13.0918 9.54841 13.0183C9.51797 12.9449 9.43374 12.91 9.36026 12.9404Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6026 9.57799L11.3595 11.0809L11.8426 11.7257L11.5258 10.9849L10.6026 9.57799Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20636 12.2245C9.12751 12.2349 9.07201 12.3072 9.08239 12.386C9.09277 12.4649 9.1651 12.5204 9.24395 12.51C9.3228 12.4996 9.3783 12.4273 9.36792 12.3484C9.35754 12.2696 9.28521 12.2141 9.20636 12.2245Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2771 9.2983L11.6192 10.9459L11.919 11.6938L11.8047 10.8962L11.2771 9.2983Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24541 11.4925C9.16656 11.4822 9.09423 11.5377 9.08385 11.6165C9.07347 11.6954 9.12897 11.7677 9.20782 11.7781C9.28667 11.7885 9.359 11.733 9.36938 11.6541C9.37976 11.5753 9.32426 11.5029 9.24541 11.4925Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 9.20164L11.9066 10.8816L12.0026 11.6816L12.0986 10.8816L12.0026 9.20164Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47034 10.797C9.39686 10.7665 9.31263 10.8014 9.28219 10.8749C9.25176 10.9484 9.28665 11.0326 9.36013 11.0631C9.4336 11.0935 9.51784 11.0586 9.54827 10.9851C9.5787 10.9117 9.54381 10.8274 9.47034 10.797Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7259 9.29743L12.1984 10.8953L12.084 11.6929L12.3838 10.945L12.7259 9.29743Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86674 10.1819C9.80365 10.1335 9.71325 10.1454 9.66484 10.2085C9.61643 10.2716 9.62833 10.362 9.69142 10.4104C9.75452 10.4588 9.84491 10.4469 9.89333 10.3838C9.94174 10.3207 9.92984 10.2303 9.86674 10.1819Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3981 9.57672L12.4749 10.9836L12.1581 11.7245L12.6412 11.0796L13.3981 9.57672Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4094 9.68993C10.361 9.62683 10.2706 9.61493 10.2075 9.66335C10.1444 9.71176 10.1325 9.80215 10.1809 9.86525C10.2293 9.92834 10.3197 9.94024 10.3828 9.89183C10.4459 9.84342 10.4578 9.75302 10.4094 9.68993Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9797 10.0213L12.7239 11.1413L12.2261 11.7749L12.8596 11.2771L13.9797 10.0213Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 9.35929C11.0321 9.28581 10.9479 9.25092 10.8744 9.28136C10.8009 9.31179 10.766 9.39603 10.7965 9.4695C10.8269 9.54298 10.9111 9.57787 10.9846 9.54743C11.0581 9.517 11.093 9.43276 11.0625 9.35929Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.424 10.6017L12.921 11.3585L12.2762 11.8417L13.017 11.5248L14.424 10.6017Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7785 9.20636C11.7681 9.12751 11.6957 9.07201 11.6169 9.08239C11.538 9.09277 11.4825 9.1651 11.4929 9.24395C11.5033 9.3228 11.5756 9.3783 11.6545 9.36792C11.7333 9.35754 11.7888 9.28521 11.7785 9.20636Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7046 11.2771L13.057 11.6192L12.3091 11.919L13.1067 11.8047L14.7046 11.2771Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5094 9.24346C12.5198 9.16461 12.4643 9.09227 12.3854 9.08189C12.3066 9.07151 12.2343 9.12702 12.2239 9.20586C12.2135 9.28471 12.269 9.35705 12.3478 9.36743C12.4267 9.37781 12.499 9.3223 12.5094 9.24346Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8003 12.0007L13.1203 11.9047L12.3203 12.0007L13.1203 12.0967L14.8003 12.0007Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 9.46936C13.2364 9.39589 13.2015 9.31165 13.128 9.28122C13.0545 9.25078 12.9703 9.28567 12.9399 9.35915C12.9094 9.43262 12.9443 9.51686 13.0178 9.54729C13.0913 9.57773 13.1755 9.54284 13.2059 9.46936Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7055 12.7249L13.1076 12.1974L12.31 12.0831L13.0579 12.3828L14.7055 12.7249Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.821 9.86674C13.8694 9.80365 13.8575 9.71325 13.7944 9.66484C13.7314 9.61643 13.641 9.62833 13.5925 9.69142C13.5441 9.75452 13.556 9.84491 13.6191 9.89333C13.6822 9.94174 13.7726 9.92984 13.821 9.86674Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4272 13.4L13.0203 12.4769L12.2794 12.16L12.9243 12.6432L14.4272 13.4Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.314 10.4094C14.3771 10.361 14.389 10.2706 14.3406 10.2075C14.2921 10.1444 14.2018 10.1325 14.1387 10.1809C14.0756 10.2293 14.0637 10.3197 14.1121 10.3828C14.1605 10.4459 14.2509 10.4578 14.314 10.4094Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9846 13.9797L12.8645 12.7239L12.231 12.2261L12.7288 12.8596L13.9846 13.9797Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6427 11.0616C14.7161 11.0311 14.751 10.9469 14.7206 10.8734C14.6902 10.7999 14.6059 10.765 14.5325 10.7955C14.459 10.8259 14.4241 10.9101 14.4545 10.9836C14.485 11.0571 14.5692 11.092 14.6427 11.0616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4003 14.424L12.6434 12.921L12.1603 12.2762L12.4771 13.017L13.4003 14.424Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7966 11.7775C14.8754 11.7671 14.9309 11.6948 14.9205 11.6159C14.9102 11.5371 14.8378 11.4816 14.759 11.4919C14.6801 11.5023 14.6246 11.5747 14.635 11.6535C14.6454 11.7324 14.7177 11.7879 14.7966 11.7775Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7258 14.7037L12.3837 13.0561L12.0839 12.3082L12.1983 13.1057L12.7258 14.7037Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2022_998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaIn);
export default __webpack_public_path__ + "static/media/India (IN).9e21efb597e6c5de3033c213de22b07a.svg";
export { ForwardRef as ReactComponent };